@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper">
  <div class="apply-form-main">

    <!--Start 1st absents Information  -->
    @if (user_absent.length != 0) {
      <div class="create-form pt-2 pl-4 pr-4 border">
        <div class="mb-2">
          <h5>Apply Leave for Absents</h5>
        </div>
        <div class="month-leaves-main mb-2">
          @for (absents of user_absent; track absents) {
            <div class="leave-card"
              [ngClass]="{'selected': absents.date === select_Date}" (click)="selectDate(absents.date)">
              <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.5 4.5H0.5M7 0.5V2.5M3 0.5V2.5M4.25 6.5L5 6V8.5M4.375 8.5H5.625M2.9 10.5H7.1C7.94008 10.5 8.36012 10.5 8.68099 10.3365C8.96323 10.1927 9.1927 9.96323 9.33651 9.68099C9.5 9.36012 9.5 8.94008 9.5 8.1V3.9C9.5 3.05992 9.5 2.63988 9.33651 2.31901C9.1927 2.03677 8.96323 1.8073 8.68099 1.66349C8.36012 1.5 7.94008 1.5 7.1 1.5H2.9C2.05992 1.5 1.63988 1.5 1.31901 1.66349C1.03677 1.8073 0.8073 2.03677 0.66349 2.31901C0.5 2.63988 0.5 3.05992 0.5 3.9V8.1C0.5 8.94008 0.5 9.36012 0.66349 9.68099C0.8073 9.96323 1.03677 10.1927 1.31901 10.3365C1.63988 10.5 2.05992 10.5 2.9 10.5Z"
                  stroke="#555555" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M9.5 4.5H0.5M7 0.5V2.5M3 0.5V2.5M4.25 6.5L5 6V8.5M4.375 8.5H5.625M2.9 10.5H7.1C7.94008 10.5 8.36012 10.5 8.68099 10.3365C8.96323 10.1927 9.1927 9.96323 9.33651 9.68099C9.5 9.36012 9.5 8.94008 9.5 8.1V3.9C9.5 3.05992 9.5 2.63988 9.33651 2.31901C9.1927 2.03677 8.96323 1.8073 8.68099 1.66349C8.36012 1.5 7.94008 1.5 7.1 1.5H2.9C2.05992 1.5 1.63988 1.5 1.31901 1.66349C1.03677 1.8073 0.8073 2.03677 0.66349 2.31901C0.5 2.63988 0.5 3.05992 0.5 3.9V8.1C0.5 8.94008 0.5 9.36012 0.66349 9.68099C0.8073 9.96323 1.03677 10.1927 1.31901 10.3365C1.63988 10.5 2.05992 10.5 2.9 10.5Z"
                    stroke="black" stroke-opacity="0.2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <p>{{ absents.date | date: 'dd MMM' }}</p>
                </div>
              }
            </div>
          </div>
        }
        <!--End 1st Section Personal Information -->



        <!-- modal -->
        <div class="modal fade" id="leaveinfoModal" tabindex="-1" role="dialog" aria-labelledby="leaveinfoModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content ">
              <div class="modal-header">
                <h5 class="modal-title" id="leaveinfoModalLabel">Leave Count Detail</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body info-modal-body">
                <div class="row">
                  <div class="col-4 p-0">
                    <div class="col-head">
                      Category
                    </div>
                  </div>
                  <div class="col-4 p-0">
                    <div class="col-data col-center">
                      Assign Leaves
                    </div>
                  </div>
                  <div class="col-4 p-0">
                    <div class="col-data col-center">
                      Remaining Leaves
                    </div>
                  </div>
                  @for (item of remainleaves; track item) {
                    <div class="col-4 p-0">
                      <div class="col-head">
                        {{item.leave_name | titlecase
                        }} <span class="leave_type">({{item.leave_type | titlecase }})</span>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center assign-leave-bg">
                        <div>
                          {{item.assigned_leaves}}
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{item.assigned_leaves - item.leave_count | number:'1.0-2'}}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--  -->
        <form id="form-link-outside-btn" #f="ngForm" (ngSubmit)="onSubmit(f)">
          <!--Start 1st Section Personal Information  -->
          <div class="create-form bottom-margin pt-2 pl-4 pr-4 border">
            <div class="main-heading-section">
              <h5> 
               {{ isEdit ? 'Edit' : 'Create New' }} Leave</h5>
              <div class="information-icon" data-toggle="modal" data-target="#leaveinfoModal" (click)="leaveInfo()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.0001 13.3337V10.0003M10.0001 6.66699H10.0084M18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C5.39771 18.3337 1.66675 14.6027 1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003Z"
                    stroke="#555555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                      d="M10.0001 13.3337V10.0003M10.0001 6.66699H10.0084M18.3334 10.0003C18.3334 14.6027 14.6025 18.3337 10.0001 18.3337C5.39771 18.3337 1.66675 14.6027 1.66675 10.0003C1.66675 5.39795 5.39771 1.66699 10.0001 1.66699C14.6025 1.66699 18.3334 5.39795 18.3334 10.0003Z"
                      stroke="black" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
                <div class="form-wrapper mb-4">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <label>Leave Title</label>
                        <input type="text" name="title" id="title" placeholder="Type here" class="form-control" ngModel
                          #title="ngModel" [ngModel]="hidenData.title" required placeholder="Enter Leave Title Here">
                        </div>
                        @if (title.invalid && (title.touched || title.dirty)) {
                          <div class="warning">
                            Title required.
                          </div>
                        }
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cars">Leave Type</label>
                          <select id="leave_type_id" name="leave_type_id"
                            class="dropdown-toggle checks-dropdown form-control selectpicker" ngModel #leave_type_id="ngModel"
                            (change)="checkType($event.target, leave_type_id.value)" [ngModel]="hidenData.leave_type_id" required>
                            <option value="" selected disabled>Select Leave Type</option>
                            <option value="3">Short Leave</option>
                            <option value="2">Full Leave</option>
                          </select>
                          @if (leave_type_id.invalid && (leave_type_id.touched || leave_type_id.dirty)) {
                            <div class="warning">
                              Leave Type required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="cars">Leave Category</label>
                          <select id="leave_name" #leave_name="ngModel" name="leave_name" class="form-control selectpicker"
                            [ngModel]="hidenData.leave_name" (change)="onLeaveNameChange($event)" required>
                            @for (leave of leavenames; track leave) {
                              <option [value]="leave.leave_name">{{ leave.leave_name }}</option>
                            }
                          </select>
                          @if (leave_name.invalid && (leave_name.touched || leave_name.dirty)) {
                            <div class="warning">
                              Leave name is required.
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="leave_payment_status">Paid/Unpaid</label>
                          <select id="leave_payment_status" name="leave_payment_status" class="form-control selectpicker"
                            [(ngModel)]="selectedPaymentStatus" required>
                            <option value="" disabled hidden>Select Paid/Unpaid</option>
                            @for (type of leave_types; track type) {
                              <option [value]="type.leave_type">
                                {{ type.leave_type }}
                              </option>
                            }
                          </select>
                          @if (selectedPaymentStatus === '') {
                            <div class="warning">
                              Paid/Unpaid selection is required.
                            </div>
                          }
                        </div>
                      </div>
                      @if (!isHidden) {
                        <div class="col-md-6">
                          <div class="form-group">
                            <label for="start_date">Start Date</label>
                            <input [type]="inputType" name="start_date" id="start_date" [(ngModel)]="start_date_form"
                              [value]="hidenData.startDate ? hidenData.startDate : start_date_form" class="form-control date-type"
                              (focus)="onFocus('start')" (blur)="onBlur('start')" placeholder="Select Start Date" required />
                              @if (start_date_form == null && isTouched) {
                                <div class="warning">
                                  Start Date required.
                                </div>
                              }
                            </div>
                          </div>
                        }

                        @if (!isHidden ) {
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="end_date">End Date</label>
                              <input [type]="inputType1" name="end_date" id="end_date" [(ngModel)]="end_date_form"
                                [value]="hidenData.end_date ? hidenData.end_date : end_date_form" class="form-control date-type"
                                (change)="changeEndDate(f.value)" (focus)="onFocus('end')" (blur)="onBlur('end')"
                                placeholder="Select End Date" required />
                                @if (end_date_form == null && isEndDateTouched) {
                                  <div class="warning">
                                    End Date required.
                                  </div>
                                }
                              </div>
                            </div>
                          }

                          <!-- <div class="col-12" *ngIf="isHidden"> -->
                          @if (isHidden) {
                            <div class="date-ShortLeave col-md-6">
                              <div class="form-group">
                                <label for="date_for_short_leave">Date</label>
                                <input type="text" placeholder="Date" onfocus="this.type='date'; this.showPicker()"
                                  onblur="if(!this.value) this.type='text'" name="date_for_short_leave" id="date_for_short_leave"
                                  [(ngModel)]="get_date_for_short_leave" #date_for_short_leave="ngModel" class="form-control date-type"
                                  required />
                                  @if (date_for_short_leave.invalid && (date_for_short_leave.touched || date_for_short_leave.dirty)) {
                                    <div class="warning"
                                      >
                                      Date required.
                                    </div>
                                  }
                                </div>
                              </div>
                            }

                            <!-- <div class="time-ShortLeave" *ngIf="isHidden"> -->
                            <!-- <div class="form-group shortTime-wrapper time-ShortLeave"> -->
                            @if (isHidden) {
                              <div class="form-group col-md-6">
                                <div class=" container-shortTime">
                                  <label for="">Start Time</label>
                                  <input type="time" placeholder="Start Time" name="shortleave_start_time" id="shortleave_start_time"
                                    [(ngModel)]="shortleave_data_startTime" #shortleave_start_time="ngModel" required
                                    (ngModelChange)="calculateWorkingHours()" />
                                    @if (shortleave_start_time.invalid && (shortleave_start_time.touched || shortleave_start_time.dirty)) {
                                      <div class="warning "
                                        >
                                        Start time required.
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                              @if (isHidden) {
                                <div class="form-group col-md-6">
                                  <div class="container-shortTime">
                                    <label for="">End Time</label>
                                    <input type="time" placeholder="End Time" name="shortleave_end_time" id="shortleave_end_time" 
                                      [(ngModel)]="shortleave_data_endTime" #shortleave_end_time="ngModel" required
                                      (change)="changeEndDate(f.value)" (ngModelChange)="calculateWorkingHours()" />
                                      @if (shortleave_end_time.invalid && (shortleave_end_time.touched || shortleave_end_time.dirty)) {
                                        <div class="warning "
                                          >
                                          End time required.
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (isHidden) {
                                  <div class="form-group col-md-6">
                                    <div class="container-shortTime">
                                      <label for="">Hours</label>
                                      <input type="number" name="shortleave_time" id="shortleave_time" [(ngModel)]="shortleave_data_time"
                                        placeholder="Hours" #shortleave_time="ngModel" required disabled>
                                        @if (shortleave_time.invalid && (shortleave_time.touched || shortleave_time.dirty)) {
                                          <div class="warning"
                                            >
                                            Hour required.
                                          </div>
                                        }
                                      </div>
                                    <!-- </div> -->
                                    <!-- <div class="warning "
                                    *ngIf="shortleave_start_time.invalid && (shortleave_start_time.touched || shortleave_start_time.dirty)">
                                    Start time required.
                                  </div>
                                  <div class="warning "
                                    *ngIf="shortleave_end_time.invalid && (shortleave_end_time.touched || shortleave_end_time.dirty)">
                                    End time required.
                                  </div>
                                  <div class="warning" *ngIf="shortleave_time.invalid && (shortleave_time.touched || shortleave_time.dirty)">
                                    Hour required.
                                  </div> -->
                                <!-- </div> -->
                              <!-- </div> -->
                            </div>
                          }

                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="cars">Assigned For</label>
                              <select id="leave_action" name="leave_action" class="form-control selectpicker"
                                [(ngModel)]="selectedLeaveType" (change)="onLeaveTypeChange($event)">
                                <option value="self">Self</option>
                                @if (user_role !== 'Employee' ) {
                                  <option value="other">Others</option>
                                }
                              </select>
                            </div>
                          </div>
                          @if (selectedLeaveType === 'other') {
                            <div class="col-md-6">
                              <div class="form-group form-field user-staff">
                                <label for="staff_data">Staff Data</label>
                                <div class="input-icon">
                                  <img [src]="selectedUserImage ? selectedUserImage : 'assets/images/fake-profile.jpg'" alt="Icon"
                                    class="input-icon">
                                  </div>
                                  <input type="text" name="userData" id="userData" [(ngModel)]="selectedUserName"
                                    placeholder="Un-Assigned" class="form-control filter-other" autocomplete="off" required
                                    (ngModelChange)="filterUsers()" />
                                    <i class="fa fa-search"></i>
                                    <div class="staff-detail-wrraper">
                                      @for (user of filteredUsers; track user) {
                                        <div class="staff-data-main" (mousedown)="selectUser(user)">
                                          <div class="staff-image">
                                            <img [src]="user.profile_image ? user.profile_image : 'assets/images/question.jpg'" alt="missing">
                                          </div>
                                          <div class="staff-name">
                                            <p>{{user.first_name}} {{user.last_name}}</p>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                              }

                              <div class="col-md-6">

                                <div class="form-group mb-0 ml-2 mt-2">

                                  <label for="staff_data">Attachment</label>
                                  <div class="col-md-12 m-0 p-0 d-flex">

                                    <!-- <div class="selected-image mr-2" *ngIf="selectedImage; else selectedPDF"> -->
                                    @if (selectedImage;) {
                                      <div class="selected-image mr-2">
                                        <img [src]="selectedImage" alt="Selected Image" />
                                      </div>
                                    }

                                    <!-- <div *ngIf="selectedPDF">
                                    <embed src="selectedPDF" type="application/pdf" width="100%" height="500px" />
                                  </div> -->
                                  <div class="upfile btn btn-md">
                                    Upload File
                                    <!-- <input type="file" name="profile_image"
                                    id="profile_image" accept="image/*,.pdf*" class="file btnPointer" (change)="onFileChange($event)"
                                    #profile_image_input /> -->
                                    <input type="file" name="profile_image" id="profile_image" accept="image/*" class="file btnPointer"
                                      (change)="onFileChange($event)" #profile_image_input />
                                      <input type="hidden" name="leave_attachment" [(ngModel)]="imagePath" id="userImage">
                                    </div>
                                    @if (profileImageInvalid) {
                                      <div class="warning-media mt-1 ml-2">
                                        Image Size exceeds limit (max 1025 KB).
                                      </div>
                                    }
                                  </div>
                                  @if (selectedFileName) {
                                    <div class="warning-media">
                                      {{ selectedFileName }}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 pl-0 pr-0">
                              <div class="form-group">
                                <label for="cars">Description</label>
                                <ckeditor [editor]="Editor" [(ngModel)]="text" id="" rows="3" name="description" ngModel
                                  #description="ngModel" required [ngModel]="hidenData.description">
                                </ckeditor>
                              </div>
                              @if (
                                description.valid &&
                                (description.dirty || description.touched)
                                ) {
                                <div>
                                  @if (text.trim().length < 150) {
                                    <p class="alert alert-warning">
                                      Ensure that the entered <strong>Description</strong> contains
                                      a minimum of 150 characters.
                                    </p>
                                  }
                                </div>
                              }
                              <!-- automated text here -->
                              @if (leaveautotemplateData.length > 0) {
                                <div class="mt-4">
                                  <!-- <p>Automated Text</p> -->
                                  @for (item of leaveautotemplateData; track item) {
                                    <div>
                                      <p class="truncate clickable" (click)="setReason(item.text)">{{ item.text }}</p>
                                    </div>
                                  }
                                </div>
                              }
                              <!-- <div *ngIf="suggestedTemplates.length > 0" class="tooltip-suggestion"> (change)="onEditorChange($event)"
                              <p>Detected template keyword(s):</p>
                              <div *ngFor="let template of suggestedTemplates">
                                <button (click)="applyTemplate(template.content)">
                                  Insert "{{ template.keyword | titlecase }}" Template
                                </button>
                              </div>
                            </div> -->
                          </div>

                        </div>
                      </div>

                      <!-- above -->

                      <!--End 1st Section Personal Information -->
                    </form>
                    <div class="footer-button">
                      <div class="btn-float-right">
                        <div (click)="backward()" class="leave-cancel">
                          Cancel
                        </div>

                        <button type="submit"  [disabled]="text.trim().length < 150" class="btn leave-save ml-2" form="form-link-outside-btn">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </main>